export const DECK_TABS = ['memorize', 'leaderboard', 'info', 'settings'];

export function getDeckTab(search) {
  const tab = new URLSearchParams(search).get('tab');
  return DECK_TABS.includes(tab) ? tab : 'memorize';
}
